import { get } from '@lumapps/constants';

/**
 * Get the developer portal URL based on the current environment
 * @returns The right developer portal URL
 */
export const getDeveloperPortalUrl = (): string => {
    const { isDev, isStaging, isSandbox } = get();

    // Staging environment
    if (isStaging) {
        return 'https://developer-stag.lumapps.com/portal/extensions';
    }

    // Development environment
    if (isSandbox || isDev) {
        return 'https://developer-devel.lumapps.com/portal/extensions';
    }

    // Production environment (default)
    return 'https://developer.lumapps.com/portal/extensions';
};
